import { Navigate } from 'react-router';
import { Box, CircularProgress } from '@mui/material';
import { useAuthStore } from '../../store/authStore';

interface RouteWrapperProps {
  children: React.ReactNode;
}

// Protected route wrapper component
export default function ProtectedRoute({ children }: RouteWrapperProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  // Don't redirect while checking auth status
  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={48} color="primary" />
      </Box>
    );
  }

  // Only redirect if we're sure the user isn't authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

// Public route wrapper component
export function PublicRoute({ children }: RouteWrapperProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  // Don't redirect while checking auth status
  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={48} color="primary" />
      </Box>
    );
  }

  // Only redirect if we're sure the user is authenticated
  if (isAuthenticated) {
    return <Navigate to="/leads" replace />;
  }

  return <>{children}</>;
}

// Not found route wrapper component
export function NotFoundRoute({ children }: RouteWrapperProps) {
  return <>{children}</>;
}
